const segmentsOf = (path: string) => path.split(/[?#]/)[0].split('/').filter(Boolean);

type Options = {
  /** Match only the exact path. Off by default, where a tab stays current for every page beneath it. */
  exact?: boolean;
};

/**
 * Whether `href` is the current page, or an ancestor of it.
 *
 * Compares whole path SEGMENTS, so `/events` is current on `/events/42` and not on `/events-archive`.
 * This is `useNavTabs`' rule, lifted out of the router hook so the component can take a plain
 * `pathname` and never import `react-router`. Query strings and hashes on either side are ignored.
 *
 * `/` matches only `/`. Read as an ancestor it would match every page and leave a root tab current
 * whatever the user opened.
 */
export const isActiveRoute = (pathname: string, href: string, { exact = false }: Options = {}) => {
  const target = segmentsOf(href);
  const current = segmentsOf(pathname);

  if (target.length === 0) {
    return current.length === 0;
  }

  if (exact && target.length !== current.length) {
    return false;
  }

  return target.every((segment, index) => current[index] === segment);
};
